import { useEffect, useState } from 'react'

// Fetch once on mount; keep `fallback` until real data arrives. Never throws in the UI.
export function useApi(fn, fallback) {
  const [data, setData] = useState(fallback)
  useEffect(() => {
    let alive = true
    fn()
      .then((d) => {
        if (alive && d != null) setData(d)
      })
      .catch(() => {})
    return () => {
      alive = false
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  return data
}
